import React from "react";
import { Switch } from "@headlessui/react";
import clsx from "clsx";

export default function ClientInfoToggles({ value = {}, onChange }) {
  const upd = (p)=>onChange({ ...value, ...p });
  return (
    <div className="grid gap-3 text-sm">
      <Toggle
        label="Phone required"
        checked={value.phone_required||false}
        onChange={(c)=>upd({phone_required:c})}
      />
    </div>
  );
}

function Toggle({ label, checked, onChange }) {
  return (
    <div className="flex items-center justify-between">
      <span>{label}</span>
      <Switch
        checked={checked}
        onChange={onChange}
        className={clsx(
          checked ? "bg-blue-600" : "bg-gray-200",
          "relative inline-flex h-6 w-11 items-center rounded-full transition"
        )}
      >
        <span
          className={clsx(
            checked ? "translate-x-6" : "translate-x-1",
            "inline-block h-4 w-4 transform rounded-full bg-white transition"
          )}
        />
      </Switch>
    </div>
  );
}
